export default {
  async plannedSchedules(params) {
    const response = await Vue.http.post('schedule/journeys/planned_schedules', params, {
      skipLoading: true
    })
    return response
  },
  async plannedSchedulesOpt(params) {
    const response = await Vue.http.post('schedule/journeys/planned_schedules_otp', params, {
      skipLoading: true
    })
    return response
  }
}
